module.exports = __webpack_public_path__ + "media/images/flags/32/Hungary-ca85ca7ba2af4eb837100b629dae5713.png";